import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormulaViewerAdapter from 'automation-ui-action-features/actions/formula/FormulaViewerAdapter';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormulaActionExplainer({
  action,
  flowObjectTypeId,
  getActionLabelById,
  getActionOutputsForTargetActionById
}) {
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.formula.explainer",
    options: {
      formula: /*#__PURE__*/_jsx(FormulaViewerAdapter, {
        propertyTypeId: flowObjectTypeId,
        actionMetadata: action.metadata,
        getActionLabelById: getActionLabelById,
        actionOutputsForTargetActionById: getActionOutputsForTargetActionById(action.getActionId())
      })
    }
  });
}